import React from 'react';
import './AboutPage.css';
import CountUp from './components/CountUp';

const AboutPage = () => {
  return (
    <section className="about">
      <div className="space-bg"></div>
      <div className="spline-glow glow-1"></div>
      <div className="spline-glow glow-2"></div>
      <div className="grid-overlay"></div>
      <div className="particles-field"></div>
      
      <div className="container">
        <h2 className="neon-title">About Cryptera 2K26</h2>
        
        <div className="glass-panel main-panel">
          <p className="description">
            Cryptera 2K26 is an exciting and dynamic national-level technical symposium organized by the Department of Computer Science and Engineering at Coimbatore Institute of Technology. This premier event serves as a platform for tech enthusiasts, innovators, and students from across the country to showcase their knowledge, skills, and creativity in the rapidly evolving fields of computer science and engineering.
          </p>
        </div>

        <div className="stats-grid">
          <div className="glass-card stat-card">
            <div className="stat-value">
              <CountUp from={0} to={4000} separator="," direction="up" duration={2} />+
            </div>
            <div className="stat-text">Participants Last Year</div>
          </div>
          <div className="glass-card stat-card">
            <div className="stat-value">
              ₹<CountUp from={0} to={75} direction="up" duration={2} />K+
            </div>
            <div className="stat-text">Prize Pool</div>
          </div>
        </div>

        <div className="glass-panel highlights-panel">
          <h3 className="highlights-title">Event Highlights</h3>
          <ul className="highlights-list">
            <li>National-level technical symposium</li>
            <li>40+ technical and non-technical events</li>
            <li>Flagship events including Project Showcase and PC Building</li>
            <li>Comprehensive workshops on latest technologies</li>
            <li>Industry experts as judges and speakers</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AboutPage;